export const SOCKET_DISCONNECT = 'socket_disconnect';
export const SOCKET_CONNECT = 'socket_connect';
export const SOCKET_OPENED = 'socket_opened';
export const SOCKET_ERROR = 'socket_error';
export const SOCKET_CLOSED = 'socket_closed';